import React, { useContext, useState } from 'react';
import { FilterContextData } from 'contexts/FilterContext';
import useSavePreset from 'hooks/Filter/useSavePreset';
import useFetchAllPresets from 'hooks/Filter/useFetchLoadAllPresets';
import SaveSelectionPresetsModal from 'components/molecules/Filter/SaveSelectionPresetsModal';
import LoadPresetsModal from 'components/molecules/Filter/LoadPresetsModal';
import { sendNotification } from 'utils/helperMethods';

interface Props {
    isFiltersPane: boolean;
    isSaveOpen: boolean;
    setIsSaveOpen: Function;
}

/**
 * The slot under the panel header: "Load Preset" on the filter pane, the applied preset
 * name on the applied-filters pane. Owns both preset modals and their queries.
 */
function FilterV2PresetSection({ isFiltersPane, isSaveOpen, setIsSaveOpen }: Props) {
    const {
        applyFilterObject,
        allCheckedAttribute,
        allSelectedValueForAllAttribute,
        timePeriodSelection,
        timeSelectionLabel,
        fetchSinglePresetWrapper,
        selectedPresetInfoObj,
        disablePresetFilter,
    } = useContext(FilterContextData);

    const [isLoadOpen, setIsLoadOpen] = useState(false);
    const { loading: savePresetLoading, savePreset } = useSavePreset({ onComplete: () => setIsSaveOpen(false) });
    const { loading: fetchAllPresetsLoading, fetchAllPresets, data: fetchAllPresetsData } = useFetchAllPresets();

    function onLoadPresetClick() {
        const userEmail = localStorage.getItem('email');
        if (!userEmail)
            return sendNotification('error', 'Please login to the application again to perform this action.');
        fetchAllPresets({ variables: { userId: userEmail } });
        setIsLoadOpen(true);
    }

    //called when clicked on save button inside preset modal
    function onSaveClick(item: any) {
        const userEmail = localStorage.getItem('email');
        if (!userEmail)
            return sendNotification('error', 'Please login to the application again to perform this action.');
        savePreset({
            variables: {
                presetFilterJson: JSON.stringify({
                    filterObj: { applyFilterObject, allCheckedAttribute, allSelectedValueForAllAttribute },
                    timePeriodFilterObj: { timePeriodSelection, timeSelectionLabel },
                }),
                presetFilterName: item.label,
                userEmail,
                defaultFlag: item.isDefault,
            },
        });
    }

    if (disablePresetFilter) return null;

    return (
        <>
            <div className="px-4 pb-4 pt-3">
                {isFiltersPane ? (
                    <div
                        role="button"
                        className="w-full h-[26px] border border-filterV2Border rounded font-xxs leading-[18px] text-filterV2TextPrimary flex justify-center items-center cursor-pointer"
                        onClick={() => onLoadPresetClick()}
                    >
                        Load Preset
                    </div>
                ) : (
                    selectedPresetInfoObj?.value && (
                        <div
                            title={selectedPresetInfoObj.value}
                            className="w-full h-[26px] px-2 bg-filterV2PrimaryBg text-filterV2Primary rounded font-xxs leading-[18px] flex justify-center items-center truncate"
                        >
                            {selectedPresetInfoObj.value}
                        </div>
                    )
                )}
            </div>
            <SaveSelectionPresetsModal
                loading={savePresetLoading}
                onSaveClick={onSaveClick}
                isOpen={isSaveOpen}
                setIsOpen={setIsSaveOpen}
            />
            <LoadPresetsModal
                loading={fetchAllPresetsLoading}
                onLoad={(item: any) =>
                    fetchSinglePresetWrapper({ presetFilterName: item.value, defaultFlag: item.isDefault })
                }
                presetsList={fetchAllPresetsData}
                isOpen={isLoadOpen}
                setIsOpen={setIsLoadOpen}
            />
        </>
    );
}

export default FilterV2PresetSection;
